import React, { Component } from 'react'
import Converter from './Converter'
export default class Home extends Component {
  getMarkDownContent() {
    const content = `
<img src="/logo.png" alt="SOOCRATE" style="display: block;margin-left: auto;margin-right: auto;width: 25%;margin-top: -12%;margin-bottom: 5%;">

<iframe  style="display: block;margin-left: auto;margin-right: auto;width: 50%;margin-bottom: 5%;"  width="560" height="315" src="https://www.youtube.com/embed/Nd1cOFa9sHQ" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

Soocrate is developed within three research projects: "Web of Browsers" in collaboration with the company [APIZEE](https://apizee.com/) and the [ASAP](https://www.irisa.fr/asap/), the CominLabs project [DESCENT](http://www.descent.cominlabs.ueb.eu/) and the ANR project [SocioPlug](http://socioplug.univ-nantes.fr/). 
The Soocrate editor is mainly developed by [GDD team](https://sites.google.com/site/gddlina/), [LINA](https://www.lina.univ-nantes.fr/), [Nantes University](http://www.univ-nantes.fr/)

**Soocrate** aims to enable collaborative editing anywhere, at anytime, whatever the number of participants, without third party. Compared to Google Docs:
            
- **Soocrate**  does not limit the number of simultaneous users,
                
- **Soocrate**  does not rely on service providers, thus your documents belong to you and whom you trust.

> **Note:** **Soocrate**  is still in its very early stage of development. Therefore, the application may be buggy. Also, even basic functionalities are not implemented yet. 
Feel free to [request functionalities, report issues, and ask questions](https://github.com/nhaouari/CRATE/issues).

`

    return content
  }

  render() {
    return (
      <div
        className="textContent"
        dangerouslySetInnerHTML={{
          __html: Converter.getHtmlFromMarkDown(this.getMarkDownContent())
        }}
      />
    )
  }
}
